<template>
	<div
		v-if="
			typeof currentLiveInventoryId !== 'undefined' &&
			currentLiveInventoryId !== null &&
			currentLiveInventoryId.toString().length > 0 &&
			!liveMode
		"
	>
		<a
			class="bannerLink backgroundColorDefault bannerContainer"
			:href="
				'/items/' +
				currentLiveInventoryId +
				'/' +
				'?advanceWithPodium=true&inventoryId=' +
				currentLiveInventoryId
			"
		>
			Click here to join the Live Auction
		</a>
	</div>
	<div v-else-if="liveMode">
		<a :href="exitUrl" class="backgroundColorLightGrey bannerContainer"
			>Click here to leave the Live Auction</a
		>
	</div>
	<div v-else-if="banner !== false">
		<a class="bannerLink backgroundColorDefault bannerContainer" :href="banner.link || '/'">
			{{ banner.copy }}
		</a>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "Banner",
    data() {
        return {
            banner: false
        }
    },
	computed: {
		exitUrl: function () {
			return window.active_auction_url || "/";
		},
		currentLiveInventoryId: function () {
			return this.$store.getters.currentLiveInventoryId;
		},
		Podium: function () {
			return this.$store.getters.podium;
		},
		liveMode: function () {
			return this.$store.getters.liveMode;
		},
		showCustomBanner: function () {
			const now = moment();
			// REMINDER - Date/Time must be in UTC
			// Start Feb 19 at 3:00PM ET
			const start = moment("2025-02-19T20:00:00.000Z");
			// End Feb 19 at 6:00PM ET
			const end = moment("2025-02-19T23:00:00.000Z");
			if (now.isAfter(start) && now.isBefore(end)) {
				return true;
			}
			return false;
		},
		customBannerMessage: function () {
			// TODO: this can come from a $store getter if we want to extend this functionality in the future
			return "Our Office & Gallery are closed due to inclement weather.";
		},
	},
    mounted() {
        this.getCustomBanners();
    },
	methods: {
		getUrlParameter: function (name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
			let results = regex.exec(location.search);
			return results === null
				? ""
				: decodeURIComponent(results[1].replace(/\+/g, " "));
		},
        getCustomBanners: function () {
            this.$store.dispatch('getCustomBanners').then(response => {
                this.banner = response.data.message_id == 'GET_BANNER_SUCCESS' ? 
                    response.data.payload.banner : false;
            });
        }
	},
};
</script>

<style scoped></style>
